module.exports = __webpack_public_path__ + "static/media/Animals.3997813f.mp3";